import { jsx as _jsx } from "react/jsx-runtime";
import Add16 from '@carbon/icons-react/es/add/16';
import { Button } from 'components/atoms/button/button';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
const BaseAddButton = (props)=>/*#__PURE__*/ _jsx(Button, {
        icon: /*#__PURE__*/ _jsx(Add16, {}),
        type: "primary",
        iconPlacement: "right",
        ...props
    });
export const AddButton = withHideIfNotAllowed(BaseAddButton);
